import * as React from "react";
import * as commonMethod from "../../commonMethods";
import ConfirmationUserGroupDeleteComponent from "../sharedComponents/ConfirmationUserGroupDeleteComponent";

import Select, { components } from "react-select";
//import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import history from "../../history";
import { getLoggedInUSerName } from "../../adalConfig";
import { CSVLink } from "react-csv";
import * as companyService from "../../services/companyComponent.service";
const CaretDownIcon = () => {
  return <div className="number_arrow"></div>;
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};
export class GroupAddComponent extends React.Component<any, any> {
  csvPartnerMessage:React.RefObject<any>;
  constructor(props: any, state: any) {
    super(props);
    this.csvPartnerMessage = React.createRef();
    this.state = {
      messageCsv:[],
      Email: this.props.Email !== undefined ? this.props.Email : "",
      RegistrationDate:
        this.props.RegisterationDate !== undefined
          ? this.props.RegisterationDate
          : "",
      UsedCredit:
        this.props.UsedCredits !== undefined ? this.props.UsedCredits : "",
      UniqueNumberCost:
        this.props.UniqueNumberCost !== undefined
          ? this.props.UniqueNumberCost
          : "",
      DefaultCountryCode:
        this.props.defaultCountryCodeForAddEditUserPRops !== undefined
          ? this.props.defaultCountryCodeForAddEditUserPRops
          : "",
      SubscriptionId:
        this.props.SubscriptionId !== undefined
          ? this.props.SubscriptionId
          : "",
      StoreText: this.props.StoreText ? this.props.StoreText : false,
      Role: this.props.RoleId !== undefined ? this.props.RoleId : 20,
      UniqueNumber:
        this.props.uniquePhoneNumber !== undefined
          ? this.props.uniquePhoneNumber
          : "",
      Disabled:
        this.props.DisableGroup !== undefined ? this.props.DisableGroup : false,
      CreditLimit:
        this.props.creditLimitForAddEditUserProp !== undefined
          ? this.props.creditLimitForAddEditUserProp
          : "",
      Name: this.props.Name !== undefined ? this.props.Name : "",
      ErrorEmail: "",
      ErrorPhoneNumber: "",
      ErrorSubscription: "",
      InvalidEmail: "",
      subscriptionList: [],
      ServicePlanId:"",
      SelectedSubscName:
        this.props.SubscriptionName !== undefined
          ? this.props.SubscriptionName
          : "",
      ErrorName: "",
      activeTab: "Group Details",
      unAssignedNumbers: [],
      ErrorCreditLimit: "",
      emailEnabled:
        this.props.emailEnabledProps !== undefined
          ? this.props.emailEnabledProps
          : false,
      emailText: false,
      alternateEmail:
        this.props.editData !== undefined
          ? this.props.editData.ContactEmail || ""
          : "",
      whiteLabel:
        this.props.editData && this.props.editData.WhiteLabelBrand
          ? this.props.editData.WhiteLabelBrand
          : "",
    };
  }
  componentDidMount() {
    if (this.props.calledFrom === "edit") {
      var data =
        this.props.subscriptionList !== undefined
          ? this.props.subscriptionList
              .filter(
                (opt: any) => opt.subscription.Id === this.state.SubscriptionId
              )
              .map((ele: any) => ele.subscription.Name)[0]
          : "";
      this.setState({
        SelectedSubscName: data,
      });
    }
    //console.log(this.props.editData);
    //console.log(this.props.companyId);
  }
  async PartnerMessage()
  {
   //debugger;
   let datareturned=this.state.LoggedInUserCompanyVersionNo === 2?(await companyService.GeneratePartnerMessageSnapshotForUser_v2(this.state.Email)):(await companyService.GeneratePartnerMessageSnapshotForUser(this.state.Email));
   datareturned = datareturned.replace(/["']/g, "");
   if(datareturned=="")
   {
     alert("Sorry, there are no messages for this group in the last seven days.");
     return;
   }
   this.setState({ messageCsv:datareturned });
   this.csvPartnerMessage.current.link.click();
 }
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (
      nextProps.subscriptionList !== prevState.subscriptionList ||
      nextProps.defaultCountryCodeForAddEditUserPRops !==
        prevState.DefaultCountryCode ||
      nextProps.uniquePhoneNumber !== prevState.UniqueNumber ||
      nextProps.unAssignPhoneNumberProps !== prevState.unAssignedNumbers ||
      nextProps.creditLimitForAddEditUserProp !== prevState.CreditLimit
    ) {
      //console.log(nextProps.subscriptionList)
      return {
        CreditLimit: nextProps.creditLimitForAddEditUserProp,
        UniqueNumber: nextProps.uniquePhoneNumber,
        DefaultCountryCode: nextProps.defaultCountryCodeForAddEditUserPRops,
        unAssignedNumbers: nextProps.unAssignPhoneNumberProps,
        subscriptionList:
          nextProps.subscriptionList !== undefined &&
          nextProps.subscriptionList.length !== 0
            ? nextProps.subscriptionList.sort((a: any, b: any) =>
                a.subscription.Name > b.subscription.Name
                  ? 1
                  : a.subscription.Name < b.subscription.Name
                  ? -1
                  : 0
              )
            : nextProps.subscriptionList,
      };
    } else return null;
  }

  IsValid() {
    var isValid = true;
    if (this.state.Email.length === 0) {
      this.setState({ ErrorEmail: "This Field is Required" });
      isValid = false;
    }
    if (this.state.Name.length === 0) {
      this.setState({ ErrorName: "This Field is Required" });
      isValid = false;
    }
    if (
      this.state.SubscriptionId.length === 0 ||
      this.state.ErrorSubscription !== ""
    ) {
      isValid = false;
      if (this.state.SubscriptionId.length === 0) {
        this.setState({
          ErrorSubscription: "This Field is Required",
        });
      }
    }
    if (this.state.ErrorPhoneNumber !== "") {
      isValid = false;
    }

    return isValid;
  }

  addUpdateData = () => {
    if (
      this.state.Email.length !== 0 &&
      commonMethod.validEmail(this.state.Email) === false
    ) {
      return false;
    }
    if (this.IsValid() === true) {
      if (
        this.state.emailEnabled !== this.props.emailEnabledProps ||
        this.state.alternateEmail !==
          ((this.props.editData && this.props.editData.ContactEmail) || "")
      ) {
        const emailData = {
          enabled: this.state.emailEnabled,
          contactEmail: this.state.alternateEmail,
          userEmail: this.state.Email,
        };
        this.props.updateUserEmailNotifications(emailData);
      }
      var dateObj = new Date();
      var regData = dateObj.toISOString();
      var creditLimit =
        this.state.CreditLimit === undefined ||
        this.state.CreditLimit === "" ||
        this.state.CreditLimit === "null"
          ? null
          : this.state.CreditLimit;
      if (this.props.calledFrom === "edit") {
        var dataBody = {
          email: this.state.Email,
          subscriptionId: parseInt(this.state.SubscriptionId),
          storeText: this.state.StoreText,
          role: this.state.Role,
          usedCredit: this.state.UsedCredit,
          registrationDate: this.state.RegistrationDate,
          rooms: {},
          uniqueNumber: this.state.UniqueNumber,
          uniqueNumberCost:
            this.state.UniqueNumberCost === ""
              ? 0
              : parseFloat(this.state.UniqueNumberCost),
          defaultCountryCode:
            this.state.DefaultCountryCode === ""
              ? 1
              : parseInt(this.state.DefaultCountryCode),
          disabled: this.state.Disabled,
          isgroup: true,
          creditLimit: creditLimit,
          username: this.state.Name,
          emailEnabled: this.state.emailEnabled,
          contactEmail: this.state.alternateEmail,
          whiteLabelBrand: this.state.whiteLabel,
        };
        //console.log(dataBody);
        this.props.addUpdateUserProp("edit", dataBody);
      } else {
        var data = {
          email: this.state.Email,
          subscriptionId: parseInt(this.state.SubscriptionId),
          storeText: this.state.StoreText,
          role: this.state.Role,
          uniqueNumber: this.state.UniqueNumber,
          uniqueNumberCost:
            this.state.UniqueNumberCost === ""
              ? 0
              : parseFloat(this.state.UniqueNumberCost),
          defaultCountryCode:
            this.state.DefaultCountryCode === ""
              ? 1
              : parseInt(this.state.DefaultCountryCode),
          disabled: this.state.Disabled,
          registrationDate: regData,
          creditLimit: creditLimit,
          isgroup: true,
          username: this.state.Name,
          emailEnabled: this.state.emailEnabled,
          contactEmail: this.state.alternateEmail,
          whiteLabelBrand: this.state.whiteLabel,
        };
        this.props.addUpdateUserProp("add", data, null);
      }
    }
  };
  subscriptionChange = (opt: any) => {
    this.props.getUnAssignedNumbers_groups(null, opt.value);
    this.setState({ SubscriptionId: opt.value, SelectedSubscName: opt.label });
    var selectedSubscrition = this.state.subscriptionList.filter((x: any) => {
      return x.subscription.Id === opt.value;
    })[0];
    this.props.setSubscriptionId(opt.value);
    this.props.setSubscriptionName(opt.label);
    if (
      (selectedSubscrition.subscription.ServicePlanId === 1 &&
        selectedSubscrition.subscription.IncludeGroups === true) ||
      selectedSubscrition.subscription.ServicePlanId === 4 ||
      selectedSubscrition.subscription.ServicePlanId === 5 ||
      selectedSubscrition.subscription.ServicePlanId === 6 ||
      selectedSubscrition.subscription.ServicePlanId === 7
    ) {
      this.setState({
        ErrorSubscription: "",
        servicePlanId: opt.ServicePlanId,
      });
    } else {
      this.setState({
        ErrorSubscription: "Requires Group Subscription",
      });
      this.setState({ servicePlanId: opt.ServicePlanId });
    }
  };
  buyButtonMethod = () => {
    if (this.props.calledFrom === "edit") {
      history.push("Numbers", {
        callingFrom: "Company:editGroup",
        companyId: this.props.companyId,
      });
    } else {
      history.push("Numbers", {
        callingFrom: "Company:addGroup",
        companyId: this.props.companyId,
      });
    }
  };

  releaseNumberFromYakchat = () => {
    const userData = getLoggedInUSerName();
    const data = {
      PhoneNumber: this.props.uniquePhoneNumber,
      Type: 0,
      CompanyId: this.props.companyId,
      ServiceProviderAccountId: 0,
      Trial: false,
      OnlyReceiveMFA: false,
      CreatedBy: userData.userName,
      ModifiedBy: userData.userName,
      CreatedDateTime: new Date(),
      ModifiedDateTime: new Date(),
    };
    this.props.removeNumberFromYakchat(data, "", this.props.calledFrom);
  };
  showBuyButton = () => {
    return this.state.UniqueNumber !== "" ? (
      <button
        type="button"
        className="btn btn-primary"
        onClick={(e) => {
          this.props.releaseNumberFromApi(this.state.UniqueNumber);
          this.releaseNumberFromYakchat();
        }}
      >
        Release Number
      </button>
    ) : (
      <button
        type="button"
        className="btn btn-primary"
        disabled={this.state.ErrorSubscription !== "" ? true : false}
        onClick={(e) => this.buyButtonMethod()}
      >
        Buy Number
      </button>
    );
  };
  renderButtonHtml = () => {
    return (
      <div className="col-12">
        <div className="btnDiv d-flex justify-content-between align-items-center">
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.addUpdateData}
            >
              Save changes
            </button>
            {this.props.roleOfLoggedInUser === -10 &&
            this.props.companyId !== undefined
              ? this.showBuyButton()
              : null}
            <button
              type="button"
              className="btn btn-default cancelBtn"
              onClick={() => this.props.changeState()}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => this.PartnerMessage()} 
              className="btn downloadBtn">
               <i className="ion ion-md-download"></i>
               &nbsp; Message Log
            </button>
            <CSVLink  data={this.state.messageCsv}  filename="Partner_Message.csv"  className="hidden"  ref={this.csvPartnerMessage}  target="_blank" /> 
         
          </div>
          <div>
            {this.props.calledFrom === "edit" ? (
              <button
                type="button"
                className="btn btn-primary delete_btn"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                <span className="font-icon">&#107;</span>Delete
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  creditLimitValidation = (e: any) => {
    var validCredit = commonMethod.validCredit(e.target.value);
    if (validCredit === true) {
      this.props.setCreditLimit(parseFloat(e.target.value));
      this.setState({ ErrorCreditLimit: "" });
    } else if (e.target.value === "null" || e.target.value === "") {
      this.props.setCreditLimit(e.target.value);
      this.setState({ ErrorCreditLimit: "" });
    } else {
      this.setState({
        ErrorCreditLimit: "Credit Limit should be between 0-999",
      });
      this.props.setCreditLimit(e.target.value);
    }
  };
  renderHtml() {

    return (
    
      this.state.subscriptionList === undefined ? (
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
      <div className="nav-tabs-top">
        <div className="tab-content border-0">
          <div className="tab-pane fade show active" id="user-edit-account">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-6">
                  <div className="formDiv">
                    <div className="row text-left">
                      <div className="col-md-6">
                        <div
                          className={
                            this.state.ErrorEmail !== "" ||
                            this.state.InvalidEmail !== ""
                              ? "form-group validationClass"
                              : "form-group"
                          }
                        >
                          <label className="form-label">
                            Email<small className="text-muted">*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              this.props.calledFrom === "edit" ? true : false
                            }
                            name="validation-email"
                            placeholder="Email"
                            onChange={(e) => {
                              var valid = commonMethod.validEmail(
                                e.target.value
                              );
                              if (!valid) {
                                this.setState({
                                  InvalidEmail:
                                    "Please Enter Valid Email Address",
                                });
                              } else {
                                this.setState({ InvalidEmail: "" });
                              }
                              this.props.setEmail(e.target.value);
                              this.setState({
                                Email: e.target.value,
                                ErrorEmail: "",
                              });
                            }}
                            value={this.state.Email}
                          />
                          <small className="form-text">
                            {this.state.ErrorEmail}{" "}
                          </small>
                          <small className="form-text">
                            {this.state.InvalidEmail}{" "}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div
                          className={
                            this.state.ErrorName !== ""
                              ? "form-group validationClass"
                              : "form-group"
                          }
                        >
                          <label className="form-label">
                            Name<small className="text-muted">* </small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="validation-email"
                            placeholder="Name"
                            onChange={(e) => {
                              this.props.setName(e.target.value);
                              this.setState({
                                Name: e.target.value,
                                ErrorName: "",
                              });
                            }}
                            value={this.state.Name}
                          />
                          <small className="form-text">
                            {this.state.ErrorName}{" "}
                          </small>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div
                          className={
                            this.state.ErrorSubscription !== ""
                              ? "form-group validationClass zIndex"
                              : "form-group zIndex"
                          }
                        >
                          <label className="form-label">
                            Subscription<small className="text-muted">* </small>
                          </label>
                          <Select
                            classNamePrefix={
                              this.state.ErrorSubscription !== ""
                                ? " validationClass"
                                : ""
                            }
                            components={{
                              DropdownIndicator,
                            }}
                            onChange={(opt: any) =>
                              this.subscriptionChange(opt)
                            }
                            value={[
                              {
                                label: this.state.SelectedSubscName===undefined?this.props.subscriptionList
                                .filter(
                                  (opt: any) => opt.subscription.Id === this.state.SubscriptionId
                                )
                                .map((ele: any) => ele.subscription.Name)[0]:this.state.SelectedSubscName,
                                value: this.state.SubscriptionId,
                              },
                            ]}
                            options={
                              this.state.subscriptionList !== undefined
                                ? this.state.subscriptionList.map(
                                    (opt: any) => ({
                                      label: opt.subscription.Name,
                                      value: opt.subscription.Id,
                                    })
                                  )
                                : null
                            }
                          />
                          <small className="form-text ">
                            {this.state.ErrorSubscription}{" "}
                          </small>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Used Credits</label>
                          <input
                            type="number"
                            className="form-control"
                            onChange={(e) => {
                              this.setState({
                                UsedCredit: parseInt(e.target.value),
                              });
                            }}
                            value={this.state.UsedCredit}
                            disabled={true}
                            name="validation-email"
                            placeholder="UsedCredits"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div
                          className={
                            this.state.ErrorPhoneNumber !== ""
                              ? "form-group validationClass"
                              : "form-group"
                          }
                        >
                          <label className="form-label">Number</label>
                          <div className="textPhoneNumber">
                            {this.state.UniqueNumber}
                          </div>
                          <Select
                            className={
                              this.state.ErrorPhoneNumber !== ""
                                ? " validationClass"
                                : ""
                            }
                            isSearchable={true}
                            isClearable={true}
                            components={{
                              DropdownIndicator,
                              SingleValue: () => {
                                return null;
                              },
                            }}
                            value={[
                              {
                                label: this.state.UniqueNumber,
                                value: this.state.UniqueNumber,
                              },
                            ]}
                            onChange={(opt: any) => {
                              if (opt !== null) {
                                this.props.setUniqueNumber(opt.label);
                                this.setState({
                                  ErrorPhoneNumber: "",
                                  UniqueNumber: opt.label,
                                });
                              } else {
                                this.props.setUniqueNumber("");
                                this.setState({ ErrorPhoneNumber: "" });
                              }
                            }}
                            options={
                              this.state.unAssignedNumbers !== undefined
                                ? this.state.unAssignedNumbers.map(
                                    (opt: any) => ({
                                      label: opt.PhoneNumber,
                                      value: opt.PhoneNumber,
                                    })
                                  )
                                : []
                            }
                          />
                          <small className="form-text ">
                            {this.state.ErrorPhoneNumber}{" "}
                          </small>
                        </div>
                      </div>
                      {this.props.calledFrom === "edit" ? null : (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">Role</label>
                            <select
                              value={this.state.Role}
                              onChange={(e) => {
                                this.props.setRoleId(parseInt(e.target.value));
                                this.setState({
                                  Role: parseInt(e.target.value),
                                });
                              }}
                              className="custom-select"
                            >
                              <option value={20}>User</option>
                              <option value={10}> Subscription admin</option>
                              <option value={0}>Admin</option>
                            </select>
                          </div>
                        </div>
                      )}
                      {this.props.calledFrom === "edit" ? null : (
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">
                              Unique Number Cost
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              onChange={(e) => {
                                this.props.setUniqueNumberCost(e.target.value);

                                this.setState({
                                  UniqueNumberCost: parseInt(e.target.value),
                                });
                              }}
                              value={this.state.UniqueNumberCost}
                              name="validation-email"
                              placeholder="UniqueNumberCost"
                              required
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Country Code</label>
                          <Select
                            isSearchable={false}
                            isClearable={false}
                            components={{ DropdownIndicator }}
                            value={[
                              {
                                label:
                                  this.state.DefaultCountryCode === 1
                                    ? "1"
                                    : this.state.DefaultCountryCode === 44
                                    ? "44"
                                    : "61",
                                value: this.state.DefaultCountryCode,
                              },
                            ]}
                            onChange={(opt: any) => {
                              this.props.setDefaultCountryCode(
                                parseInt(opt.value)
                              );
                              this.setState({
                                DefaultCountryCode: parseInt(opt.value),
                              });
                            }}
                            options={[
                              { label: "1", value: 1 },
                              { label: "44", value: 44 },
                              { label: "61", value: 61 },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div
                          className={
                            this.state.ErrorCreditLimit !== ""
                              ? "form-group validationClass"
                              : "form-group"
                          }
                        >
                          <label className="form-label">Credit</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                              this.creditLimitValidation(e);
                            }}
                            value={
                              this.state.CreditLimit === null
                                ? ""
                                : this.state.CreditLimit
                            }
                            name="validation-email"
                            placeholder="CreditLimit"
                            required
                          />
                          <small className="form-text ">
                            {this.state.ErrorCreditLimit}{" "}
                          </small>
                        </div>
                      </div>
                      {this.props.calledFrom === "edit" ? (
                        <div className="col-md-6">
                          <div className={"form-group"}>
                            <label className="form-label">Created Date</label>
                            <input
                              type="text"
                              className="form-control"
                              name="validation-email"
                              placeholder="Created Date"
                              value={
                                this.state.RegistrationDate !== "" ||
                                this.state.RegistrationDate !== undefined
                                  ? this.state.RegistrationDate.split("T")[0]
                                  : this.state.RegistrationDate
                              }
                              required
                              disabled={true}
                            />
                          </div>
                        </div>
                      ) : null}

                      {this.props.roleOfLoggedInUser === -10 ||
                      this.props.roleOfLoggedInUser === 5 ? (
                        this.props.calledFrom === "edit" ? (
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label">White Label</label>
                              <input
                                type="text"
                                placeholder="White Label"
                                className="form-control"
                                // disabled={
                                //   this.props.roleOfLoggedInUser === 5
                                //     ? true
                                //     : false
                                // }
                                onChange={(e) => {
                                  this.setState({
                                    whiteLabel: e.target.value
                                      .trim()
                                      .toLocaleLowerCase(),
                                  });
                                }}
                                value={this.state.whiteLabel}
                              />
                            </div>
                          </div>
                        ) : null
                      ) : null}

                      {/* <div className="w-100"></div> */}
                      <div className="col-md-6">
                        {/* <div className="form-group mt-3">
                                                    <label className="custom-control custom-checkbox m-0 checkbox_right">
                                                        <input type="checkbox" className="custom-control-input"
                                                            onChange={() => {
                                                                this.props.storeTextForAddEdit(!this.state.StoreText)

                                                                this.setState({ StoreText: !this.state.StoreText });
                                                            }}
                                                            checked={this.state.StoreText} />
                                                        <span className="custom-control-label">Store Text</span>
                                                    </label>
                                                </div> */}
                        {/* <div className="form-group mt-3">
                                                    <label className="custom-control custom-checkbox m-0 checkbox_right">
                                                    <input type="checkbox" className="custom-control-input"
                                                            onChange={() => {
                                                                this.props.EmailEnabledForAddEdit(!this.state.EmailEnabled)
                                                                this.setState({ EmailEnabled: !this.state.EmailEnabled });
                                                            }}
                                                            checked={this.state.EmailEnabled} />
                                                        <span className="custom-control-label">Email Text</span>
                                                    </label>
                                                </div> */}
                      </div>
                      {this.props.calledFrom === "edit" ? (
                        <div className="col-md-6">
                          <div className="form-group mt-3">
                            <label className="custom-control custom-checkbox m-0 checkbox_right">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                onChange={() => {
                                  this.props.disableForAddEdit(
                                    !this.state.Disabled
                                  );
                                  this.setState({
                                    Disabled: !this.state.Disabled,
                                  });
                                }}
                                checked={this.state.Disabled}
                              />
                              <span className="custom-control-label">
                                Disabled
                              </span>
                            </label>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-md-12">
                        <div className="form-group enableList">
                          <label className="custom-control custom-checkbox m-0 checkbox_right">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              onChange={() => {
                                this.setState({
                                  emailEnabled: !this.state.emailEnabled,
                                });
                              }}
                              checked={this.state.emailEnabled}
                            />
                            <span className="custom-control-label">
                              Email Text
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">
                            Alternative Notification Email
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            onChange={(e) => {
                              this.setState({ alternateEmail: e.target.value });
                            }}
                            value={this.state.alternateEmail}
                            placeholder="Alternate Email address"
                            //disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {this.renderButtonHtml()}
              </div>
            </div>
          </div>
        </div>
      </div>
      )
    );
  }
  render() {
    return (
      <React.Fragment>
        <div>
          {this.props.calledFrom === "edit" ||
          (this.props.companyId !== undefined &&
            this.props.companyId !== "") ? (
            <div>
              <h4 className="font-weight-bold text-left addUser_head">
                {this.props.calledFrom === "edit" ? "" : "Add Group"}
              </h4>
              {this.renderHtml()}
            </div>
          ) : (
            <div>
              <h2 className="companyName  text-left">
                <span
                  className="iconNavigation cursor_pointer"
                  onClick={() => this.props.changeState()}
                >
                  <i
                    className="fa fa-chevron-left cursor_pointer"
                    aria-hidden="true"
                  ></i>
                </span>
                Groups / <b>New Group</b>
              </h2>
              <Tabs
                className="tabGroupMember"
                defaultActiveKey={this.state.activeTab}
                onSelect={(currentTabName: any) => {
                  this.setState({
                    activeTab: currentTabName,
                    companyName: "",
                  });
                }}
                id="uncontrolled-tab-example"
              >
                <Tab
                  eventKey="Group Details"
                  title={
                    <span>
                      <span className="font-icon">&#67;</span>Group Details
                    </span>
                  }
                >
                  {this.renderHtml()}
                </Tab>
              </Tabs>
            </div>
          )}          
          <ConfirmationUserGroupDeleteComponent
          deleteSucces={(confirm:boolean) => {
              this.props.deleteGroup(
                this.state.Email,
                this.props.companyId || -1,confirm
              );
            }}
        />
        </div>
      </React.Fragment>
    );
  }
}
